import { createActions, handleActions } from 'redux-actions';

export const types = {
  SET_CONNECTED: 'SET_CONNECTED',
  SET_CONNECTED_SUCCESS: 'SET_CONNECTED_SUCCESS',

  SET_DISCONNECTED: 'SET_DISCONNECTED',
  SET_DISCONNECTED_SUCCESS: 'SET_DISCONNECTED_SUCCESS',
};

export const {
  setConnected,
  setConnectedSuccess,
  setDisconnected,
  setDisconnectedSuccess,
} = createActions(
  types.SET_CONNECTED,
  types.SET_CONNECTED_SUCCESS,
  types.SET_DISCONNECTED,
  types.SET_DISCONNECTED_SUCCESS
);

const INIT_STATE = {
  isConnected: true,
};

const reducer = handleActions(
  {
    [types.SET_CONNECTED_SUCCESS]: () => ({
      isConnected: true,
    }),
    [types.SET_DISCONNECTED_SUCCESS]: () => ({
      isConnected: false,
    }),
  },
  INIT_STATE
);

export default reducer;
export const getConnectionStatus = (state) => state.internet.isConnected;



// WEBPACK FOOTER //
// ./src/services/redux/internet.js